import { render, staticRenderFns } from "./TotalOperation.vue?vue&type=template&id=2bbd8bcc&scoped=true&"
import script from "./TotalOperation.vue?vue&type=script&lang=js&"
export * from "./TotalOperation.vue?vue&type=script&lang=js&"
import style0 from "./TotalOperation.vue?vue&type=style&index=0&id=2bbd8bcc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbd8bcc",
  null
  
)

export default component.exports